class TimelineScroll extends HTMLElement {
  constructor() {
    super();
    this.init = false;
  }

  connectedCallback() {
    const items = this.querySelectorAll("timeline li");
    const lineToDraw = this.querySelector("draw-line");
    const timelineUl = this.querySelector("timeline ul");

    if (lineToDraw) {
      let lastKnownScrollPosition = 0;
      let ticking = false;
      let scrollDirection = "down";

      const updateRedLine = (entries) => {
        entries.forEach((entry) => {
          const item = entry.target;

          // Adjust circlePosition calculation
          const itemRect = item.getBoundingClientRect();
          const timelineUlRect = timelineUl.getBoundingClientRect();
          const circlePosition = itemRect.top + itemRect.height / 2 - timelineUlRect.top;

          const newHeight = circlePosition;

          if (entry.isIntersecting) {
            // Ensure height only increases as expected
            if (newHeight > lineToDraw.clientHeight) {
              lineToDraw.style.height = newHeight + "px";
            }

            item.classList.add("in-view");

            // If the last item is in view, extend the line to the bottom of the ul
            if (item === items[items.length - 1]) {
              lineToDraw.style.height = `${timelineUl.clientHeight}px`;
            }
          } else {
            if (scrollDirection === "up") {
              item.classList.remove("in-view");

              // Adjust the height based on the last in-view item
              const inViewItems = Array.from(items).filter((i) =>
                i.classList.contains("in-view")
              );
              if (inViewItems.length > 0) {
                const lastInViewItem = inViewItems[inViewItems.length - 1];
                const lastInViewItemRect = lastInViewItem.getBoundingClientRect();
                const lastCirclePosition =
                  lastInViewItemRect.top +
                  lastInViewItemRect.height / 2 -
                  timelineUlRect.top;

                lineToDraw.style.height = `${lastCirclePosition}px`;
              } else {
                lineToDraw.style.height = "0px";
              }
            }
          }
        });
      };

      const observer = new IntersectionObserver(updateRedLine, {
        root: null,
        rootMargin: "0px",
        threshold: 0.7,
      });

      items.forEach((item) => {
        observer.observe(item);
      });

      window.addEventListener("scroll", () => {
        const currentScrollPosition = window.scrollY;

        if (currentScrollPosition > lastKnownScrollPosition) {
          scrollDirection = "down";
        } else {
          scrollDirection = "up";
        }

        lastKnownScrollPosition = currentScrollPosition;

        if (!ticking) {
          window.requestAnimationFrame(() => {
            ticking = false;
          });

          ticking = true;
        }
      });
    }
  }
}

customElements.define("timeline-scroll", TimelineScroll);